import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  image = 'https://customer-assets.emergentagent.com/job_floral-replica-1/artifacts/unh8rooy_7fa5a7c5-3307-4cdb-82cb-350ffe23ad08-removebg-preview.png',
  url = 'https://tqmfloreria.com',
  type = 'website'
}) => {
  const fullTitle = title ? `${title} | TQM Florería Arequipa` : 'TQM Florería - Flores y Arreglos Florales en Arequipa | Delivery Express';
  const fullDescription = description || 'Florería en Arequipa con delivery express. Ramos de rosas, lirios, girasoles, arreglos florales, peluches y más. Envío el mismo día en menos de 3 horas. ¡Compra flores frescas ahora!';
  const fullKeywords = keywords || 'floreria arequipa, flores arequipa, ramos de flores arequipa, arreglos florales arequipa, delivery flores arequipa, rosas arequipa, lirios arequipa, girasoles arequipa, peluches arequipa, flores a domicilio arequipa, floreria delivery arequipa, comprar flores arequipa, flores frescas arequipa, floreria cerca de mi, floreria en arequipa, flores para regalo arequipa';

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={fullDescription} />
      <meta name="keywords" content={fullKeywords} />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="Spanish" />
      <meta name="geo.region" content="PE-ARE" />
      <meta name="geo.placename" content="Arequipa" />
      <meta name="geo.position" content="-16.409047;-71.537451" />
      <meta name="ICBM" content="-16.409047, -71.537451" />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDescription} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="es_PE" />
      <meta property="og:site_name" content="TQM Florería Arequipa" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={fullDescription} />
      <meta property="twitter:image" content={image} />

      {/* Schema.org structured data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "@id": "https://tqmfloreria.com",
          "name": "TQM Florería",
          "image": image,
          "description": fullDescription,
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "93 Av. Lambramani, José Luis Bustamante",
            "addressLocality": "Arequipa",
            "addressRegion": "Arequipa",
            "postalCode": "04001",
            "addressCountry": "PE"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": -16.409047,
            "longitude": -71.537451
          },
          "url": url,
          "telephone": "+51959389799",
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday"
              ],
              "opens": "08:00",
              "closes": "21:00"
            }
          ],
          "sameAs": [
            "https://www.instagram.com/tqmfloreria.pe",
            "https://www.facebook.com/tqmflores",
            "https://www.tiktok.com/@tqmfloreria"
          ],
          "servesCuisine": "Flores y Arreglos Florales",
          "areaServed": {
            "@type": "City",
            "name": "Arequipa"
          }
        })}
      </script>
    </Helmet>
  );
};

export default SEO;